export const LOGGER_FRAGMENT_ID = 'es-fragment-design-services-hub';
